import React from 'react';
import './career.css';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";
import { CiEdit } from 'react-icons/ci';

const DEFAULT_DATA = {
  bannerImage:      "",
  secondaryImage:   "",
  title:            "",
  commitmentLabel:  "",
  paragraphs:       [],
  sections:         [],
  closingText:      "",
};

const EXTRA_FIELDS = [
  { key: "commitmentLabel", label: "Commitment Label",  rows: 1 },
  { key: "closingText",     label: "Closing Paragraph", rows: 2 },
];

const EXTRA_IMAGE_FIELDS = [
  { key: "secondaryImage", label: "Secondary / Inline Image" },
];

const Csr = () => {
  const {
    pageData, loading, fetchErr, fetchData,
    modalOpen, setModalOpen, saving, handleSave, saveMsg,
  } = usePageEditor("/api/csr", DEFAULT_DATA);

  const bannerImg    = resolveUrl(pageData.bannerImage);
  const secondaryImg = resolveUrl(pageData.secondaryImage);
  const hasContent   = Boolean(pageData.title);

  return (
    <>
      <button
        title="Edit page"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: 70, right: 20, zIndex: 10, background: "rgba(255,255,255,0.9)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
      >
        <CiEdit size={24} color="#333" />
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr} <button onClick={fetchData}>Retry</button></div>}

      {modalOpen && (
        <ServiceEditModal
          data={pageData}
          onSave={handleSave}
          onClose={() => setModalOpen(false)}
          saving={saving}
          pageLabel="CSR"
          extraFields={EXTRA_FIELDS}
          extraImageFields={EXTRA_IMAGE_FIELDS}
        />
      )}

      {hasContent && (
        <>
          <div className="img_carrierse">
            {bannerImg && <img src={bannerImg} alt="img" />}
          </div>

          <div className="careers-container">
            <div className="careers-content">
              <div className="title-section">
                <h1 className="careers-title">{pageData.title}</h1>
                <div className="orange-underline"></div>
              </div>

              <div className="csr_content">
                <div className="csr_section">
                  {pageData.commitmentLabel && <p className="intro-text mkbold">{pageData.commitmentLabel}</p>}

                  {pageData.paragraphs.map((para, i) => (
                    <p className="intro-tex" key={i}>{para}</p>
                  ))}

                  {pageData.sections.map((sec, i) => (
                    <div key={i}>
                      <p className="intro-text">{sec.heading}</p>
                      <ul className="catext">
                        {sec.items.map((item, j) => <li key={j}>{item}</li>)}
                      </ul>
                    </div>
                  ))}

                  {pageData.closingText && <p className="intro-text">{pageData.closingText}</p>}
                </div>

                {secondaryImg && (
                  <div className="img_cover">
                    <div className="img_carr">
                      <img src={secondaryImg} alt="img" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

    </>
  );
};

export default Csr;